// Transform our filter and pagination state into the format expected by filterUrlHelper

// Filters for the URL of a data request by the page,
// which includes the filters explicitly included in the page URL but
// also those not in the page URL that should be included in the data request URLs.
function dataUrlFilterOptions(state) {
  const defaultFilters = {}
  // Check existing filters on the page, add default filters if page filter isn't present for the filter key
  const filterKeys = state.filters.map(f => f.type)
  const filtersToAdd = Object.entries(defaultFilters).filter(([k]) => !filterKeys.includes(k)).map(([k, v]) => ({
    type: k,
    value: v
  }))
  return {
    filters: [...state.filters, ...filtersToAdd],
    pagination: {currentPage: state.pagination.page},
    otherSearchParams: {
      search_strategy: state.searchStrategy
    }
  }
}

// Filters for the URL of the `points` data requested by the page. We never filter this by the searched-for location
// so users are able to pan the map. We do filter it to see different types of objects or by other properties of the events.
function pointsUrlOptions(state) {
  return {
    filters: state.filters.filter(f => f.type!=='location')
  }
}

export { pointsUrlOptions, dataUrlFilterOptions }
